var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { useCombobox } from 'downshift';
import { FloatingContextProvider } from '../utils/floating/index.js';
import { SearchableSelectButton } from './SearchableSelectButton.js';
import { SearchableSelectContext } from './SearchableSelectContext.js';
import { SearchableSelectItem, SearchableSelectItems, SearchableSelectItemsEmpty, } from './SearchableSelectItems.js';
export const SearchableSelect = (props) => {
    const { children, value, options, onChange, className, disabled = false, onInputChange } = props, rest = __rest(props, ["children", "value", "options", "onChange", "className", "disabled", "onInputChange"]);
    const dsCombobox = useCombobox({
        selectedItem: value,
        items: options,
        itemToString: () => '',
        onSelectedItemChange: changes => {
            onChange(changes.selectedItem);
        },
        onInputValueChange: changes => {
            onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(changes.inputValue);
        },
        stateReducer: (state, actionAndChanges) => {
            const { changes, type } = actionAndChanges;
            switch (type) {
                case useCombobox.stateChangeTypes.InputKeyDownEnter:
                case useCombobox.stateChangeTypes.ItemClick:
                case useCombobox.stateChangeTypes.InputBlur:
                    return Object.assign(Object.assign({}, changes), { inputValue: '' });
                default:
                    return changes;
            }
        },
    });
    return (React.createElement("div", Object.assign({ className: clsx('relative isolate', className) }, rest),
        React.createElement(SearchableSelectContext.Provider, { value: Object.assign(Object.assign({}, dsCombobox), { disabled }) },
            React.createElement(FloatingContextProvider, { placement: "bottom-start" }, children))));
};
SearchableSelect.Button = SearchableSelectButton;
SearchableSelect.Items = SearchableSelectItems;
SearchableSelect.ItemsEmpty = SearchableSelectItemsEmpty;
SearchableSelect.Item = SearchableSelectItem;
//# sourceMappingURL=SearchableSelect.js.map